export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'm4v', 'webm'];
export const PDF_EXTENSIONS = ['pdf'];

export function getFileExtension(file) {
    return String(file || '').split('.').pop().toLowerCase();
}

export function isImageFile(file) {
    return IMAGE_EXTENSIONS.includes(getFileExtension(file));
}

export function isVideoFile(file) {
    return VIDEO_EXTENSIONS.includes(getFileExtension(file));
}

export function isPdfFile(file) {
    return PDF_EXTENSIONS.includes(getFileExtension(file));
}

export default function getMediaType(file) {
    const fileType = getFileExtension(file);

    const mediaTypes = {
        pdf: "application/pdf",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        bmp: "image/bmp",
        svg: "image/svg",
        txt: "text/plain",
        xls: "application/vnd.ms-excel",
        xlsx: "application/vnd.ms-excel",
        csv: "application/vnd.ms-excel",
        doc: "application/msword",
        docx: "application/msword",
        rtf: "application/msword",
        xlsm: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        mp4: "video/mp4",
        m4v: "video/mp4",
        mov: "video/quicktime",
        webm: "video/webm",
        mp3: "audio/mpeg",
        wav: "audio/wav",
        flac: "audio/flac",
    };

    if (Object.hasOwn(mediaTypes, fileType)) {
        return mediaTypes[fileType];
    }

    return null
};
